import React, { useState, useEffect } from 'react';
import { Transaction } from '../types/Transaction';
import { useApi } from '../services/apiService';
import { formatShortDate, formatSignedMoney } from '../utils/format';
import './CreditTransactionDropdown.css';

interface CreditTransactionDropdownProps {
  parentTransactionId: string;
  onLinkTransaction: (
    parentTransactionId: string,
    creditTransactionId: string,
  ) => void;
}

const CreditTransactionDropdown: React.FC<CreditTransactionDropdownProps> = ({
  parentTransactionId,
  onLinkTransaction,
}) => {
  const [creditTransactions, setCreditTransactions] = useState<Transaction[]>(
    [],
  );
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const { fetchCreditTransactions } = useApi();

  const loadMore = async () => {
    if (!hasMore || loading) return;
    setLoading(true);
    try {
      const transactions = await fetchCreditTransactions(page);
      setCreditTransactions((prev) => [...prev, ...transactions]);
      setHasMore(transactions.length > 0);
      setPage((prev) => prev + 1);
    } catch (error) {
      console.error('Failed to fetch credit transactions:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMore();
  }, []);

  return (
    <div className="credit-transaction-dropdown">
      <div className="credit-transaction-heading">Pick a credit to link</div>
      <ul className="credit-transaction-list">
        {creditTransactions.map((transaction) => (
          <li key={transaction.id}>
            <button
              className="credit-transaction-item"
              onClick={() =>
                onLinkTransaction(parentTransactionId, transaction.id)
              }
            >
              <span className="credit-transaction-date">
                {formatShortDate(transaction.date)}
              </span>
              <span className="credit-transaction-description">
                {transaction.description}
              </span>
              <span className="credit-transaction-amount num">
                {formatSignedMoney(Number(transaction.amount))}
              </span>
            </button>
          </li>
        ))}
      </ul>
      <div className="credit-transaction-footer">
        {loading ? (
          'Loading...'
        ) : hasMore ? (
          <button className="credit-transaction-more" onClick={loadMore}>
            Load more credits
          </button>
        ) : (
          'No more transactions'
        )}
      </div>
    </div>
  );
};

export default CreditTransactionDropdown;
